module.exports = __webpack_public_path__ + "img/Lucas Manuel.5797b0a3.jpg";